const BaseRefObject = function(){
    return {
        id: null,
        name: "",
        associated_ref_id: null,
        associated_ref: {
            id: null
        },
        sight_ref_cat_id: null,
        sight2_scores: {f1: 0,f2: 0,f3: 0,f4: 0,c1: 0,c2: 0,c3: 0,c4: 0,t1: 0,t2: 0,t3: 0,t4: 0,t5: 0,t6: 0,t: 0,e: 0,s: 0},
        sight3_scores: {r1: 0,r2: 0,r3: 0,r4: 0,r5: 0,r6: 0,r7: 0,r8: 0,r9: 0,r10: 0,r11: 0,r12: 0,r13: 0,r14: 0,r15: 0,r16: 0,r17: 0},
        coeffs: {r1: 0,r2: 0,r3: 0,r4: 0,r5: 0,r6: 0,r7: 0,r8: 0,r9: 0,r10: 0,r11: 0,r12: 0,r13: 0,r14: 0,r15: 0,r16: 0,r17: 0}
    }
}
export default BaseRefObject